import { ProductService } from "./../../../services/catalogs/ProductService";
import React from "react";
import { ProductDetail } from "../../../components/Pages/Catalogs/Product/ProductDetail";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupProduct } from "../../../components/Shared/NewForms/NFLookupProduct";
import ProductList from "../../../components/Pages/Catalogs/Product/ProductList";
import { ProductGroupDetail } from "../../../components/Pages/Catalogs/Product/ProductGroupDetail";
import {CreateProductDto} from "../../../dtos/catalogs/Products/CreateProductDto";
import {ProductTypeEnum} from "../../../enums/Products/ProductTypeEnum";

const catalogName = "products";
export const Product: IAppEntity = {
  entityType: "catalog",
  title: "Product",
  pluralTitle: "Products",
  apiUrl: catalogName,
  isHierarchy: true,
  apiEnum: ReferenceTypes.CatalogProduct,

  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) => {
    return React.createElement(ProductDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },

  // Tree List View Component
  getGroupViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) => {
    if (model) {
      model.isGroup = true;
    }
    return React.createElement(ProductGroupDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },

  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ProductList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupProduct, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService(): ProductService {
    return new ProductService(this.apiUrl);
  },
  getEmptyModel(): CreateProductDto {
    return {
      name: "",
      createdDate: new Date(),
      uniqueCode: "",
      productType: ProductTypeEnum.Product,
    };
  },
};
